import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);

import MultCoachesBar from "./mult-coaches-bar";
import SimpleVideo from "./simple-video";
import {DEFER_INIT_EVENTS} from "../global/constants";

export default class ReviewsSlider {
	constructor(props = {}) {
		this.shouldDeferInit = props.shouldDeferInit == null ? true : props.shouldDeferInit;
		this.id = 'swiper-reviews';
		this.$root = document.getElementById(this.id);
		this.videoList = [];

		this.swiper = null;

		if (this.$root) {
			this.$slides = this.$root.querySelectorAll('.swiper-slide');

			this.config = {
				navigation: {
					nextEl: '.swiper-slider-next',
					prevEl: '.swiper-slider-prev',
					disabledClass: 'swiper-slider-disabled'
				},
				pagination: {
					el: '.swiper-slider_pagination',
					clickable: true,
					dynamicBullets: this.$slides.length > 7,
					dynamicMainBullets: 3
				},
				spaceBetween: 30,
				slidesPerView: 1,
				slidesPerGroup: 1,
				loop: this.$slides.length > 1,
				autoHeight: true,
				on: {
					init: function () {
						setTimeout(() => {
							this.updateAutoHeight(250);
						}, 250);
					},
					slideChange: () => {
						if (this.videoList.length) {
							this.videoList.forEach((video) => {
								video.pause();
							});
						}
					}
				}
			};

			if (this.shouldDeferInit) {
				this.deferInit();
			} else {
				this.init();
			}
		}
	}

	init() {
		this.initVideo();
		this.bootstrap();
		this.handlePagination();
		this.initMultCoachesBars();
	}

	deferInit() {
		const events = DEFER_INIT_EVENTS;
		const handler = e => {
			e.stopPropagation();

			this.initVideo();
			this.bootstrap();
			this.handlePagination();
			this.initMultCoachesBars();
			lozadObserver.observe();

			events.forEach(event => {
				window.removeEventListener(event, handler);
			});
		};


		events.forEach(event => {
			window.addEventListener(event, handler);
		});
	}

	initMultCoachesBars() {
		const $bars = this.$root.querySelectorAll('.mult-coaches-bar');
		if ($bars.length) {
			$bars.forEach(($bar) => {
				const multCoachesBar = new MultCoachesBar({ $root: $bar });

				multCoachesBar.collapsible.subscribe('toggleCollapsible', () => {
					this.swiper.updateAutoHeight(360);
				});
			});
		}
	}

	bootstrap() {
		this.swiper = new Swiper(`#${this.id}`, this.config);
	}

	handlePagination() {
		const $bulletCollection = this.$root.querySelectorAll('.swiper-pagination-bullet');

		if ($bulletCollection.length === 1) {
			this.$root.classList.add('-no-pagination');
		} else {
			this.$root.classList.remove('-no-pagination');
		}
	}

	initVideo() {
		const $videos = this.$root.querySelectorAll('.review-video');

		if (!$videos.length) return;

		this.videoList = Array.from($videos).map(($video) => new SimpleVideo($video));
	}
}